module.exports = __webpack_public_path__ + "img/map.c0076ad6.png";